import { render, staticRenderFns } from "./WxPaySuccessOverlay.vue?vue&type=template&id=5f423faf&scoped=true&"
import script from "./WxPaySuccessOverlay.vue?vue&type=script&lang=js&"
export * from "./WxPaySuccessOverlay.vue?vue&type=script&lang=js&"
import style0 from "./WxPaySuccessOverlay.vue?vue&type=style&index=0&id=5f423faf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f423faf",
  null
  
)

export default component.exports